module.exports = __webpack_public_path__ + "img/8_l_uk.26770d43.svg";